import React from 'react';
import { useParams, Navigate, useSearchParams } from 'react-router-dom';
import AuthoredBookTheme from '../components/authored/AuthoredBookTheme';
import MobileAuthoredReader from '../components/mobile/MobileAuthoredReader';
import useIsMobile from '../hooks/useIsMobile';
import useBookSeo from '../utils/useBookSeo';

export default function AuthoredBookReaderPage() {
  const { book_id } = useParams();
  const [searchParams] = useSearchParams();
  const isMobile = useIsMobile();
  useBookSeo(book_id);
  const previewRaw = searchParams.get('preview');
  const previewMode =
    previewRaw === '1' || String(previewRaw).toLowerCase() === 'true';

  if (!book_id) {
    return <Navigate to="/" replace />;
  }

  if (isMobile) {
    return (
      <div className="book-reader-container min-h-screen">
        <MobileAuthoredReader bookId={book_id} previewMode={previewMode} />
      </div>
    );
  }

  return (
    <div className="book-reader-container min-h-screen">
      <AuthoredBookTheme bookId={book_id} previewMode={previewMode} />
    </div>
  );
}
